// BackupService.js — botón de copia del Vault (roadmap.fixarr.es/vault)
//
// 29/10/2026 — LAS BASES DE DATOS YA NO SE COPIAN DESDE AQUÍ.
// La copia «v6.0» llamaba a la función full-backup de cada proyecto con la clave
// pública (anon). Esa función volcaba todas las tablas, los usuarios y el esquema
// sin comprobar quién llamaba, así que cualquiera con la clave pública podía
// llevarse la base de datos entera. Está RETIRADA (responde 410) en los tres:
//   - FIXARR.ES ........ desde el 17/09/2026 (proyecto en retirada)
//   - FIXARR-TENANTS ... desde el 29/10/2026 (agujero de seguridad)
//   - FIXARR-CENTRAL ... desde el 29/10/2026 (agujero de seguridad)
// create-backup-branch (la rama «roadmap_backup_…» en GitHub) también responde
// 410 en FIXARR.ES desde el 17/09/2026. Por eso aquí ya no se llama a ninguna.
//
// La copia completa de TENANTS y CENTRAL (base de datos + archivos, cifrada) la
// hace sola cada noche .github/workflows/db-backup.yml y la sube a Google Drive.
// Este botón descarga solo el código (ZIP de la rama main en GitHub).

// GitHub
const GITHUB_ZIP_URL = 'https://github.com/redachaudri-source/tech-service-ecosystem/archive/refs/heads/main.zip';

/** Aviso que enseña el Vault junto al botón. */
export const AVISO_COPIA_BD =
    'Las bases de datos ya no se copian desde aquí: la función que lo hacía se retiró por seguridad ' +
    '(29/10/2026). La copia completa de TENANTS y CENTRAL (base de datos y archivos, cifrada) se hace ' +
    'sola cada noche y se guarda en tu Google Drive. Este botón descarga solo el código.';

// ============================================
// FUNCIÓN PRINCIPAL
// ============================================

export const createFullBackup = async (onProgress = () => { }) => {
    const now = new Date();

    // Solo el código: el ZIP de la rama main en GitHub.
    onProgress(10);
    const codeLink = document.createElement('a');
    codeLink.href = GITHUB_ZIP_URL;
    codeLink.download = 'tech-service-ecosystem-main.zip';
    document.body.appendChild(codeLink);
    codeLink.click();
    document.body.removeChild(codeLink);

    onProgress(100);

    return {
        success: true,
        date: now.toISOString(),
        codeOnly: true,
        codeFile: 'tech-service-ecosystem-main.zip',
    };
};

// 30/10/2026 (auditoría): fuera «Solo JSON» (subir/bajar un JSON del bucket «backups» de FIXARR.ES). El
// bucket es privado y está vacío desde que se retiró la copia completa: el botón no podía funcionar.

export default { createFullBackup };
